<template>
  <div v-if="visible" id="tab-hbl2">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="command1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyCargoDescriptionAndMarks')">{{ $t('SeaExport.CopyCargoDescriptionAndMarks') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-show="Boolean(form.docType)"
            no="originalPrint"
            :disabled="btnPrintDisabled"
            type="primary"
            @click="originalPrint"
          >{{ form.releaseType === 1 ? $t('SeaExport.PrintTheOriginalBl') : $t('SeaExport.TelexRelease') }}</el-button>
          <el-button
            v-show="form.state==2"
            no="onSubmitStatEvent"
            type="primary"
            @click="unlock"
          >{{ $t('SeaExport.Unlock') }}</el-button>
          <el-button
            no="showAddressFormatDialog"
            :disabled="readonly||!form.uuid"
            type="primary"
            @click="showAddressFormatDialog"
          >{{ $t('SeaExport.AntiTerroristFormattedAddress') }}</el-button>
          <el-dropdown
            v-if="!OpenXHQDocumentCenter"
            no="command2"
            style="padding-left: 5px;"
            :class="btnBLConfirmDisabled?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command2)"
            @command="p=>{command2=p;commandHandle(command2)}"
          >
            {{ command2 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.InviteToChecktheBL')">{{ $t('SeaExport.InviteToChecktheBL') }}</el-dropdown-item>
              <el-dropdown-item v-permission="['button_M/HBL_confirmBL']" :command="$t('SeaExport.ConfirmChecking')">{{ $t('SeaExport.ConfirmChecking') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_M/HBL_identification'])" :command="$t('SeaExport.IdentificationList')">{{ $t('SeaExport.IdentificationList') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CheckingHistory')">{{ $t('SeaExport.CheckingHistory') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.UploadGuarantee')">{{ $t('SeaExport.UploadGuarantee') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-menu
            v-if="OpenXHQDocumentCenter"
            :class="isEdit||!form.uuid?'is-disabled not-click':''"
            text-color="#404144"
            active-text-color="#404144"
            mode="horizontal"
            class="el-menu-button el-button el-button--primary el-button--mini"
            style="vertical-align: top"
            @select="XHQDocumentCenterSelectHandler"
          >
            <el-submenu index="index">
              <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.InviteToChecktheBL') }}</span>
              <el-menu-item index="InviteToChecktheBL">{{ $t('SeaExport.InviteToChecktheBL') }}</el-menu-item>
              <el-submenu :index="$t('SeaExport.UploadCustomerFiles')">
                <template slot="title">{{ $t('SeaExport.UploadCustomerFiles') }}</template>
                <el-menu-item index="BillOfLadingConfirmationDocument">{{ $t('Clearing.BillOfLadingConfirmationDocument') }}</el-menu-item>
                <el-menu-item index="CustomerSelfIssuedFiles">{{ $t('SeaExport.CustomerSelfIssuedFiles') }}</el-menu-item>
                <el-menu-item v-if="ToExoSystemJYD" index="OriginBillOfLading">{{ $t('SeaExport.OriginBillOfLading') }}</el-menu-item>
                <el-menu-item index="ShippingOrder">{{ $t('SeaExport.ShippingOrder') }}</el-menu-item>
              </el-submenu>
              <el-menu-item v-if="$checkPermission(['button_M/HBL_identification'])" index="IdentificationList">{{ $t('SeaExport.IdentificationList') }}</el-menu-item>
              <el-menu-item index="CheckTheBLLog">{{ $t('SeaExport.CheckTheBLLog') }}</el-menu-item>
              <el-menu-item index="ConfirmChecking">{{ $t('SeaExport.ConfirmChecking') }}</el-menu-item>
              <el-menu-item index="UploadGuarantee">{{ $t('SeaExport.UploadGuarantee') }}</el-menu-item>
            </el-submenu>
          </el-menu>
          <!-- 对单链接-->
          <el-button v-if="OpenXHQDocumentCenter && ToExoSystemJYD" :disabled="isEdit||!form.uuid" no="CustomerToOrder" type="primary" @click="onOpenDocLink(0)">{{ $t('SeaExport.CustomerToOrder') }}</el-button>
          <el-button v-if="OpenXHQDocumentCenter && ToExoSystemJYD" :disabled="isEdit||!form.uuid" no="DesignatedGoodsToBillOfLading" type="primary" @click="onOpenDocLink(1)">{{ $t('SeaExport.DesignatedGoodsToBillOfLading') }}</el-button>
          <el-button
            v-if="OpenXHQDocumentCenter"
            :disabled="isEdit"
            no="updateBillInfo"
            type="primary"
            @click="pm.updateBillInfo()"
          >{{ $t('SeaExport.ConfirmationBillOfLading') }}</el-button>
          <el-checkbox
            :value="form.state===2"
            :disabled="true"
            style="margin-left: 20px;"
          >{{ $t('SeaExport.Locked') }}</el-checkbox>
          <el-checkbox
            v-model="form.oversea"
            no="oversea"
            :disabled="readonly"
            style="margin-left: -20px"
          >{{ $t('SeaExport.BlBeReleased') }}</el-checkbox>
          <el-checkbox
            v-model="form.printParam1"
            no="printParam1"
            style="margin-left: -20px;"
            :disabled="readonly"
            @change="pm.changeSeaeq()"
          >Part of</el-checkbox>
          <el-checkbox v-model="form.printParam2" no="printParam2" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.ClauseOfNoWoodPackingMaterial') }}</el-checkbox>
          <el-checkbox
            v-model="form.printParam3"
            no="printParam3"
            style="margin-left: -20px;"
            :disabled="readonly"
            @change="val=>{pm.changeContainer(val)}"
          >{{ $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS') }}</el-checkbox>
          <el-checkbox v-model="chkConsolidationClosed" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.AFRTheLastBill') }}</el-checkbox>
          <el-checkbox
            no="customerSelfRelease"
            :value="form.customerSelfRelease===1"
            :disabled="readonly"
            @input="isCustomerSelfRelease"
          >{{ $t('SeaExport.CustomerSelfRelease') }}</el-checkbox>
          <el-checkbox
            no="customerSelfRelease2"
            :value="form.customerSelfRelease===2"
            :disabled="readonly"
            @input="isCompanySelfRelease"
          >{{ $t('SeaExport.CompanySelfRelease') }}</el-checkbox>
        </div>
      </div>
    </div>
    <div style="width: fit-content">
      <tab-HBL2-UICustom-layout :element-blocks="elementBlocks">
        <template v-if="elementDict.shipper.viewable" slot="shipper">
          <el-form-item class="auto-width">
            <template slot="label">
              <line-label :class="(elementDict.shipper.isRequire ? 'blue ' : '') + variableCss.shipperLine" :label="elementDict.shipper.label" />
              <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="shipperCode"
                v-model="form.shipperCode"
                :disabled="readonly || !elementDict.shipper.writable"
                no="shipperCode"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.shipper.writable"
                no="shipperId"
                :select-type="selectTypeNames.basic_data_Company"
                :headers="[$t('Partners.englishName')]"
                :fields="['englishName']"
                :method-params="{ shipper: true, active: true }"
                filterable
                :default-value="form.shipperId||''"
                tag-name="englishName"
                style="flex:1;"
                @parentCallBack="p=>{pm.shipperAutoCompleteChange(p)}"
              />
              <el-button type="primary" :disabled="readonly || !elementDict.shipper.writable" style="margin-left:6px" @click="pm.onClear(1)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item v-for="count in 7" :key="'shipperLine'+count" :class="'auto-width '+ getClass('shipperLine',count)">
            <cargo-input
              :ref="'shipperLine'+count"
              v-model="form['shipperLine'+count]"
              :disabled="readonly || !elementDict.shipper.writable"
              :no="'shipperLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 6 ? null :'shipperLine'+(count+1),maxChars)"
            />
          </el-form-item>
        </template>
        <template v-if="elementDict.consignee.viewable" slot="consignee">
          <el-form-item class="auto-width">
            <template slot="label">
              <line-label :class="(elementDict.consignee.isRequire ? 'blue ' : '') + variableCss.consigneeLine" :label="elementDict.consignee.label" />
              <char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="consigneeCode"
                v-model="form.consigneeCode"
                :disabled="readonly || !elementDict.consignee.writable"
                no="consigneeCode"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.consignee.writable"
                no="consigneeId"
                :select-type="selectTypeNames.basic_data_Company"
                :headers="[$t('Partners.englishName')]"
                :fields="['englishName']"
                :method-params="{ consignee: true, active: true }"
                filterable
                :default-value="form.consigneeId||''"
                tag-name="englishName"
                style="flex:1;"
                @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p)}"
              />
              <el-button no="onClear2" type="primary" :disabled="readonly || !elementDict.consignee.writable" style="margin-left:6px" @click="pm.onClear(2)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'consigneeLine'+count"
            :class="'auto-width ' + getClass('consigneeLine',count)"
          >
            <cargo-input
              :ref="'consigneeLine'+count"
              v-model="form['consigneeLine'+count]"
              :disabled="readonly || !elementDict.consignee.writable"
              :no="'consigneeLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 6 ? null :'consigneeLine'+(count+1),maxChars)"
            />
          </el-form-item>
        </template>
        <template v-if="elementDict.notify.viewable" slot="notify">
          <el-form-item class="auto-width">
            <template slot="label">
              <line-label :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
              <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div>
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="notifyCode"
                v-model="form.notifyCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="notifyCode"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="notifyId"
                :select-type="selectTypeNames.basic_data_Company"
                :headers="[$t('Partners.englishName')]"
                :fields="['englishName']"
                :method-params="{ notify: true, active: true }"
                filterable
                :default-value="form.notifyId||''"
                tag-name="englishName"
                @parentCallBack="p=>{pm.notifyAutoCompleteChange(p)}"
              />
              <div style="margin-top: 5px">
                <el-button no="onClear3" type="primary" :disabled="readonly || !elementDict.notify.writable" style="min-width: 50px" @click="pm.onClear(3)">{{ $t('SeaExport.Reset') }}</el-button>
                <el-button no="onCopy_consignee" type="primary":disabled="readonly || !elementDict.notify.writable" style="margin-left:5px;" @click="pm.onCopy_consignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'notifyLine'+count"
            :class="'auto-width ' + getClass('notifyLine',count)"
          >
            <cargo-input
              :ref="'notifyLine'+count"
              v-model="form['notifyLine'+count]"
              :disabled="readonly || !elementDict.notify.writable"
              :no="'notifyLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 6 ? null :'notifyLine'+(count+1),maxChars)"
            />
          </el-form-item>
        </template>
        <template v-if="elementDict.alsoNotify.viewable" slot="agentParty">
          <el-form-item class="auto-width">
            <line-label slot="label" :class="elementDict.agentParty.isRequire ? 'blue' : ''" :label="elementDict.agentParty.label" :style="elementDict.agentParty.isRequire ? '' : 'color:#404144!important;'" />
            <div style="text-align: right">
              <el-button no="onClear4" type="primary" :disabled="readonly || !elementDict.agentParty.writable" style="min-width: 50px;margin-right: 5px;" @click="pm.onClear(4)">{{ $t('SeaExport.Reset') }}</el-button>
              <el-dropdown
                no="command3"
                :disabled="readonly || !elementDict.agentParty.writable"
                style="margin-top: 5px;"
                :class="readonly?'not-click':''"
                split-button
                type="primary"
                @click="commandHandle(command3)"
                @command="p=>{command3=p;commandHandle(command3)}"
              >
                {{ command3 }}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="$t('SeaExport.CopyMblConsignee')">{{ $t('SeaExport.CopyMblConsignee') }}</el-dropdown-item>
                  <el-dropdown-item :command="$t('SeaExport.CopyNominatedAgentInfo')">{{ $t('SeaExport.CopyNominatedAgentInfo') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'agentPartyLine'+count"
            :class="'auto-width ' + getClass('agentPartyLine',count)"
          >
            <cargo-input
              :ref="'agentPartyLine'+count"
              v-model="form['agentPartyLine'+count]"
              :disabled="readonly || !elementDict.agentParty.writable"
              :no="'agentPartyLine'+count"
              :auto-uppercase="isUppercase"
              :use-read-only="true"
              @dblclick.native="showAgentPartyDialog"
              @change="()=>wrapAddr(form,'agentPartyLine'+count,count+1 > 6 ? null :'agentPartyLine'+(count+1),maxChars)"
            />
          </el-form-item>
        </template>
        <template v-if="elementDict.alsoNotify.viewable" slot="alsoNotify">
          <el-form-item class="auto-width">
            <line-label slot="label" :class="elementDict.alsoNotify.isRequire ? 'blue' : ''" :label="elementDict.alsoNotify.label" :style="elementDict.alsoNotify.isRequire ? '' : 'color:#404144!important'" />
          </el-form-item>
          <el-form-item class="auto-width">
            <cargo-rich-textarea
              v-model="form.alsoNotify"
              no="alsoNotify"
              :disabled="readonly || !elementDict.alsoNotify.writable"
              :text-chars="0"
              wrap-symbol="r"
              auto-half-word
              auto-uppercase
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val},true,{warningCount:45,autoUppercase:true,autoHalfWord:true})"
            />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.quantity.viewable" slot="quantity" :class="variableCss.quantity">
          <line-label slot="label" :class="elementDict.quantity.isRequire ? 'blue' : ''" :label="elementDict.quantity.label" />
          <auto-number-input
            v-model="form.quantity"
            no="quantity"
            :precision="0"
            :min="0"
            :disabled="!isJydEditJobFields || readonly || !elementDict.quantity.writable"
            @change="pm.quantity_Change()"
            @blur="hblNbr2Change"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.packing.viewable" slot="packing" :class="variableCss.packing">
          <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
          <cargo-packing-select
            no="packing"
            :default-value="form.packing"
            :disabled="readonly || !elementDict.packing.writable"
            @change="p => {pm.packing_Change(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.insideQuantity.viewable" slot="insideQuantity" :class="variableCss.insideQuantity">
          <line-label slot="label" :class="elementDict.insideQuantity.isRequire ? 'blue' : ''" :label="elementDict.insideQuantity.label" />
          <auto-number-input
            v-model="form.insideQuantity"
            no="insideQuantity"
            :precision="0"
            :min="0"
            :disabled="readonly || !elementDict.insideQuantity.writable"
            @change="hblNbr2Change"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.insidePacking.viewable" slot="insidePacking" :class="variableCss.insidePacking">
          <line-label slot="label" :class="elementDict.insidePacking.isRequire ? 'blue' : ''" :label="elementDict.insidePacking.label" />
          <cargo-packing-select
            no="insidePacking"
            :default-value="form.insidePacking"
            :disabled="readonly || !elementDict.insidePacking.writable"
            @change="p => {form.insidePacking=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.weight.viewable" slot="weight" :class="variableCss.weight">
          <line-label slot="label" :class="elementDict.weight.isRequire ? 'blue' : ''" :label="elementDict.weight.label" />
          <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
            <el-input-number
              v-model="form.weight"
              no="weight"
              :precision="3"
              :min="0"
              :controls="false"
              :disabled="!isJydEditJobFields || readonly || !elementDict.weight.writable"
              style="flex: 1"
              @change="p=>{hblNbr2Change(p);refreshWeightCharge(p);calculateChargeWeight();}"
            />
            <span>KGS</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cubage.viewable" slot="cubage" :class="variableCss.cubage">
          <line-label slot="label" :class="elementDict.cubage.isRequire ? 'blue' : ''" :label="elementDict.cubage.label" />
          <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
            <el-input-number
              v-model="form.cubage"
              no="cubage"
              :precision="3"
              :min="0"
              :controls="false"
              :disabled="!isJydEditJobFields || readonly || !elementDict.cubage.writable"
              style="flex: 1"
              @change="p=>{hblNbr2Change();calculateChargeWeight();}"
            />
            <span>CBM</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.chargeWeight.viewable" slot="chargeWeight">
          <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
          <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
            <el-input-number
              v-model="form.chargeWeight"
              no="chargeWeight"
              :precision="3"
              :min="0"
              :controls="false"
              style="flex: 1"
              :disabled="readonly || !elementDict.chargeWeight.writable"
              @change="hblNbr2Change"
            />
            <span>M/T</span>
          </div>
        </el-form-item>
        <template slot="cargoEnglishName">
          <el-form-item v-show="elementDict.cargoEnglishName.viewable" :class="'auto-width '+variableCss.cargoEnglishName">
            <div style="display: flex;justify-content: flex-end">
              <el-button v-if="job.typeHBL===BillType.MERGE_BILL_TYPE.code" no="getCargoEnglishNameFromMergeJob" :disabled="readonly || !elementDict.cargoEnglishName.writable" type="primary" @click="pm.getCargoEnglishNameFromMergeJob()">{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromMergeJob') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item v-show="elementDict.cargoEnglishName.viewable" :class="'auto-width '+variableCss.cargoEnglishName">
            <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
            <cargo-rich-textarea
              ref="cargoTextarea1"
              v-model="form.cargoEnglishName"
              :show-count="true"
              no="cargoTextarea1"
              :disabled="!isEdit || !elementDict.cargoEnglishName.writable"
              :text-chars="0"
              :warning-count="-1"
              wrap-symbol="r"
              :auto-uppercase="isUppercaseByConfig"
              auto-half-word
              style="height: 110px"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:isUppercaseByConfig})"
            />
          </el-form-item>
        </template>
        <template slot="mark">
          <el-form-item v-show="elementDict.mark.viewable" label-width="0" :class="'auto-width '+variableCss.mark">
            <div style="display: flex;justify-content: flex-end">
              <el-button v-if="job.typeHBL===BillType.MERGE_BILL_TYPE.code" no="getMarkFromMergeJob" type="primary" :disabled="readonly || !elementDict.mark.writable" @click="pm.getMarkFromMergeJob()">{{ $t('SeaExport.CopyMarkFromMergeJob') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item v-show="elementDict.mark.viewable" :class="'auto-width '+variableCss.mark">
            <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
            <cargo-rich-textarea
              ref="cargoTextarea2"
              v-model="form.mark"
              :show-count="true"
              no="cargoTextarea2"
              :text-chars="0"
              :warning-count="-1"
              wrap-symbol="r"
              :auto-uppercase="isUppercaseByConfig"
              auto-half-word
              :disabled="!isEdit || !elementDict.mark.writable"
              style="height: 110px"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},isUppercaseByConfig,{autoHalfWord: true,autoUppercase: isUppercaseByConfig})"
            />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.quantitySum.viewable" slot="quantitySum" class="auto-width">
          <line-label slot="label" :class="elementDict.quantitySum.isRequire ? 'blue' : ''" :label="elementDict.quantitySum.label" />
          <el-input v-model="form.quantitySum" :disabled="true" no="quantitySum" />
        </el-form-item>
        <el-form-item v-if="elementDict.hblNbr2.viewable" slot="hblNbr2">
          <line-label slot="label" :class="elementDict.hblNbr2.isRequire ? 'blue' : ''" :label="elementDict.hblNbr2.label" />
          <el-input v-model="form.hblNbr2" no="hblNbr2" :disabled="readonly || !elementDict.hblNbr2.writable" @input="hblNbr2Change" />
        </el-form-item>
        <el-form-item v-if="elementDict.warehouseNo.viewable" slot="warehouseNo">
          <line-label slot="label" :class="elementDict.warehouseNo.isRequire ? 'blue' : ''" :label="elementDict.warehouseNo.label" />
          <el-input v-model="form.warehouseNo" no="warehouseNo" :disabled="readonly || !elementDict.warehouseNo.writable" @change="hblNbr2Change" />
        </el-form-item>
        <el-form-item v-if="elementDict.mblId.viewable" slot="mblId">
          <line-label slot="label" :class="elementDict.mblId.isRequire ? 'blue' : ''" :label="elementDict.mblId.label" />
          <cargo-combo-box
            v-model="form.mblId"
            no="mblId"
            :disabled="readonly || splitOrder.rowData.length>0 || !elementDict.mblId.writable"
            :options="pm.joinMBLs"
            label-field="mblNbr2"
            value-field="uuid"
            :need-old-value="true"
            :forbid-values="['']"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.serialNo.viewable" slot="serialNo">
          <line-label slot="label" :class="elementDict.serialNo.isRequire ? 'blue' : ''" :label="elementDict.serialNo.label" />
          <el-input v-model="form.serialNo" no="serialNo" :disabled="readonly || !elementDict.serialNo.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.vessel.viewable" slot="vessel">
          <line-label slot="label" :class="elementDict.vessel.isRequire ? 'blue' : ''" :label="elementDict.vessel.label" />
          <cargo-advance-select
            no="vessel"
            :disabled="readonly||!pm._lclslaveEnabled || !elementDict.vessel.writable"
            :select-type="selectTypeNames.basic_data_Vessel"
            filterable
            clearable
            :allow-create="pm._allowEditingVessel"
            :default-value="job.vessel"
            style="width:100%;"
            @parentCallBack="p=>{pm.onVesselSelectionChange(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.voyageFlight.viewable" slot="voyageFlight">
          <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
          <el-select
            ref="voyageFlight"
            v-model="job.voyageFlight"
            no="voyageFlight"
            :disabled="readonly||!pm._lclslaveEnabled||pm.editVoyageMode!==1 || !elementDict.voyageFlight.writable"
            filterable
            allow-create
            @focus="pm.txtVoyagefocusInHandler()"
            @blur="pm.txtVoyagefocusOutHandler()"
          >
            <el-option
              v-for="(item,index) in pm._voyages"
              :key="index"
              :label="item.voyageNo"
              :value="item.voyageNo"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.sailingDate.viewable" slot="sailingDate">
          <line-label slot="label" :class="elementDict.sailingDate.isRequire ? 'blue' : ''" :label="elementDict.sailingDate.label" />
          <el-input :value="sailingDate" :disabled="true" no="sailingDate" />
        </el-form-item>
        <el-form-item v-if="elementDict.dispatchingPlaceCode.viewable" slot="dispatchingPlaceCode" :class="variableCss.dispatchingPlace">
          <line-label slot="label" :class="elementDict.dispatchingPlaceCode.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlaceCode.label" />
          <cargo-advance-select
            :disabled="true"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="form.dispatchingPlaceCode||''"
            tag-name="englishName"
            no="1"
            @parentCallBack="p=>{pm.portChange(p, 'dispatchingPlace')}"
          />
          <el-input v-model="form.dispatchingPlace" no="dispatchingPlace" :disabled="readonly || !elementDict.dispatchingPlaceCode.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.loadingPortCode.viewable" slot="loadingPortCode" :class="variableCss.loadingPort">
          <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
          <cargo-advance-select
            :disabled="true"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="form.loadingPortCode||''"
            tag-name="englishName"
            no="2"
            @parentCallBack="p=>{pm.portChange(p, 'loadingPort')}"
          />
          <el-input v-model="form.loadingPort" no="loadingPort" :disabled="readonly || !elementDict.loadingPortCode.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.dischargingPortCode.viewable" slot="dischargingPortCode" :class="variableCss.dischargingPort">
          <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
          <cargo-advance-select
            :disabled="true"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="form.dischargingPortCode||''"
            tag-name="englishName"
            no="3"
            @parentCallBack="p=>{pm.portChange(p, 'dischargingPort')}"
          />
          <el-input v-model="form.dischargingPort" no="dischargingPort" :disabled="readonly || !elementDict.dischargingPortCode.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPortCode.viewable" slot="destinationPortCode" :class="variableCss.destinationPort">
          <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
          <cargo-advance-select
            :disabled="true"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="form.destinationPortCode||''"
            tag-name="englishName"
            no="4"
            @parentCallBack="p=>{pm.portChange(p, 'destinationPort')}"
          />
          <el-input v-model="form.destinationPort" no="destinationPort" :disabled="readonly || !elementDict.destinationPortCode.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPlace.viewable" slot="destinationPlace">
          <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
          <el-input v-model="form.destinationPlace" no="destinationPlace" :disabled="readonly || !elementDict.destinationPlace.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.paymentTerm.viewable" slot="paymentTerm">
          <line-label slot="label" :class="elementDict.paymentTerm.isRequire ? 'blue' : ''" :label="elementDict.paymentTerm.label" />
          <cargo-advance-select
            no="paymentTerm"
            :select-type="selectTypeNames.basic_data_PaymentTerm"
            filterable
            :default-value="form.paymentTerm"
            :allow-create="true"
            style="width:100%;"
            :disabled="readonly || !elementDict.paymentTerm.writable"
            @parentCallBack="p=>{pm.paymentSelectHblChange(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.paymentPlaceBL.viewable" slot="paymentPlaceBL">
          <line-label slot="label" :class="elementDict.paymentPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.paymentPlaceBL.label" />
          <el-input v-model="form.paymentPlaceBL" no="paymentPlaceBL" :disabled="readonly || !elementDict.paymentPlaceBL.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.freightTermHBL.viewable" slot="freightTermHBL">
          <line-label slot="label" :class="elementDict.freightTermHBL.isRequire ? 'blue' : ''" :label="elementDict.freightTermHBL.label" />
          <el-input v-model="form.freightTermHBL" no="freightTermHBL" :disabled="readonly || !elementDict.freightTermHBL.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.blNumber.viewable" slot="blNumber" :class="variableCss.BLNumber">
          <line-label slot="label" :class="elementDict.blNumber.isRequire ? 'blue' : ''" :label="elementDict.blNumber.label" />
          <el-input v-model="form.blNumber" no="blNumber" :disabled="readonly || !elementDict.blNumber.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.signPlaceBL.viewable" slot="signPlaceBL">
          <line-label slot="label" :class="elementDict.signPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.signPlaceBL.label" />
          <el-input v-model="form.signPlaceBL" no="signPlaceBL" :disabled="readonly || !elementDict.signPlaceBL.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.signDateBL.viewable" slot="signDateBL">
          <line-label slot="label" :class="elementDict.signDateBL.isRequire ? 'blue' : ''" :label="elementDict.signDateBL.label" />
          <el-date-picker v-model="form.signDateBL" no="signDateBL" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="readonly || !elementDict.signDateBL.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.remarks.viewable" slot="remarks" :class="variableCss.remarks">
          <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
          <el-input
            v-model="form.remarks"
            no="remarks"
            type="textarea"
            :rows="5"
            :disabled="readonly || !elementDict.remarks.writable"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.hsCode.viewable" slot="hsCode">
          <line-label slot="label" :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
          <el-input
            v-model="form.hsCode"
            no="hsCode"
            type="textarea"
            :rows="5"
            :disabled="readonly || !elementDict.hsCode.writable"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),form.hsCode,val=>{form.hsCode=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customerCfmException.viewable" slot="customerCfmException">
          <line-label slot="label" :class="elementDict.customerCfmException.isRequire ? 'blue' : ''" :label="elementDict.customerCfmException.label" />
          <el-input
            v-model="form.customerCfmException"
            no="customerCfmException"
            type="textarea"
            :rows="5"
            :disabled="readonly || !elementDict.customerCfmException.writable"
            @dblclick.native="showAdvanceTextDialog(elementDict.customerCfmException.label,form.customerCfmException,val=>{form.customerCfmException=val})"
          />
        </el-form-item>
        <el-form-item
          v-if="elementDict.orderBusinessAssociation.viewable && job.typeHBL===BillType.SPLIT_BILL_TYPE.code"
          slot="orderBusinessAssociation"
          label-width="0"
          class="auto-width"
        >
          <cargo-ag-grid
            key="OtherInfo"
            no="OtherInfo"
            :grid-options="splitOrder.gridOptions"
            :column-defs="splitOrder.columnDefs"
            :row-data="splitOrderFinalRowData"
            :auto-fit-content="false"
            style="width:100%;height:200px"
            @gridReady="splitOrderGridReady"
          />
          <div style="padding:5px 0">
            <div style="float:right">
              <el-button no="onAddCargoDoc2" type="primary" :disabled="readonly || !elementDict.orderBusinessAssociation.writable" @click="pm.onAddCargoDoc2(true)">{{ $t('SeaExport.Add') }}</el-button>
              <el-button no="onRemoveCargoDoc" type="danger" :disabled="readonly || !elementDict.orderBusinessAssociation.writable" @click="pm.onRemoveCargoDoc()">{{ $t('SeaExport.Delete') }}</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          v-if="elementDict.orderBusinessAssociation.viewable && job.typeHBL===BillType.MERGE_BILL_TYPE.code"
          slot="orderBusinessAssociation"
          label-width="0"
          class="auto-width"
        >
          <cargo-ag-grid
            key="150004"
            no="150004"
            config-module="150004"
            :grid-options="mergeOrder.gridOptions"
            :column-defs="mergeOrder.columnDefs"
            :row-data="mergeOrderFinalRowData"
            :auto-fit-content="false"
            style="width:100%;height:200px"
            @gridReady="params=>{mergeOrder.gridApi=params.api}"
          />
          <div style="padding:5px 0">
            <div style="float:right">
              <el-button no="onMergeAddJob2" type="primary" :disabled="readonly || !elementDict.orderBusinessAssociation.writable" @click="pm.onMergeAddJob()">{{ $t('SeaExport.Add3') }}</el-button>
              <el-button no="onMergeRemoveJob2" type="danger" :disabled="readonly || !elementDict.orderBusinessAssociation.writable" @click="pm.onMergeRemoveJob()">{{ $t('SeaExport.Delete') }}</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.releaseType.viewable" slot="releaseType">
          <line-label slot="label" :class="elementDict.releaseType.isRequire ? 'blue' : ''" :label="elementDict.releaseType.label" />
          <el-select
            no="releaseType"
            :disabled="readonly || !elementDict.releaseType.writable"
            :value="form.releaseType||''"
            style="width: 100%"
            @input="val=>{form.releaseType=val}"
            @change="val=>{pm.cmbreleaseTypeMBLChangeHandler(val)}"
          >
            <el-option
              v-for="(item,index) in blModeList"
              :key="index"
              :label="item.name"
              :value="item.serialNumber"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.lblCfrState.viewable" slot="lblCfrState" class="red ">
          <line-label slot="label" :class="elementDict.lblCfrState.isRequire ? 'blue' : ''" :label="elementDict.lblCfrState.label" />
          <div style="display: flex">
            <el-input :value="lblCfrState" :disabled="true" style="flex: 1" />
            <el-link
              v-if="showXhqOverseasAgentFeedbackLink"
              no="xhqOverseasAgentFeedbackLink"
              style="color: blue;margin-left: 5px"
              @click="xhqShowOverseasAgentFeedbackDialog"
            >{{ $t('SeaExport.View') }}
            </el-link>
          </div>
        </el-form-item>

        <!-- 提单签发状态 -->
        <el-form-item v-if="elementDict.billLadingIssued.viewable" slot="billLadingIssued" class="red">
          <line-label slot="label" :class="elementDict.billLadingIssued.isRequire ? 'blue' : ''" :label="elementDict.billLadingIssued.label" />
          <el-input v-model="billLadingIssued" :disabled="true" no="6" />
        </el-form-item>
        <template v-if="elementDict.lblReleaseState.viewable" slot="lblReleaseState">
          <el-form-item label-width="0">
            <el-button
              v-if="OpenXHQDocumentCenter"
              v-permission="['button_HBL_surrendered']"
              :disabled="isEdit || !elementDict.releaseType.writable"
              no="surrendered"
              type="primary"
              @click="pm.toSurrendered()"
            >{{ $t('SeaExport.Surrendered') }}</el-button>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ReleasingStatus')" class="red ">
            <line-label slot="label" :class="elementDict.lblReleaseState.isRequire ? 'blue' : ''" :label="elementDict.lblReleaseState.label" />
            <el-input :value="lblReleaseState" :disabled="true" no="7" />
          </el-form-item>
          <el-form-item>
            <el-checkbox
              no="DataSent"
              :value="form.releaseReview===1"
              :disabled="true"
              style="margin-right: 6px;"
            >{{ $t('SeaExport.DataSent') }}</el-checkbox>
            <el-checkbox no="payable" :value="form.payable" :disabled="true" style="margin-right: 6px;">{{ $t('SeaExport.Completed') }}</el-checkbox>
            <el-checkbox no="withhold" :value="form.withhold" :disabled="true" style="margin-right: 0px;">{{ $t('SeaExport.CargoDetention') }}</el-checkbox>
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.requestReleaseState.viewable" slot="requestReleaseState" class="red">
          <line-label slot="label" :class="elementDict.requestReleaseState.isRequire ? 'blue' : ''" :label="elementDict.requestReleaseState.label" />
          <el-input :value="form.requestReleaseState === 0 ? $t('SeaExport.NotApplying') : $t('SeaExport.Requested')" :disabled="true" />
          <cargo-button-container
            no="requestReleaseState"
            :disabled="btnBLConfirmDisabled || !cooperateEdit || !elementDict.requestReleaseState.writable"
            style="float:right;margin-left:5px"
            @click="pm.btnRequestReleasingClickHandler()"
          >
            <el-button v-permission="['button_M/HBL_SingleReleaseHBL']" type="primary">{{
              form.requestReleaseState === 0 ? $t('SeaExport.ApplyForARelease') : $t('SeaExport.WithdrawTheRequestForRelease')
            }}
            </el-button>
          </cargo-button-container>
        </el-form-item>
        <el-form-item v-if="elementDict.agreePayDate.viewable" slot="agreePayDate">
          <line-label slot="label" :class="elementDict.agreePayDate.isRequire ? 'blue' : ''" :label="elementDict.agreePayDate.label" />
          <el-date-picker
            v-model="form.agreePayDate"
            :disabled="isDatePickerDisabled || readonly || !elementDict.agreePayDate.writable"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            no="8"
            @input="handleDateChange"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.withholdDate.viewable" slot="withholdDate">
          <line-label slot="label" :class="elementDict.withholdDate.isRequire ? 'blue' : ''" :label="elementDict.withholdDate.label" />
          <el-date-picker
            v-model="form.withholdDate"
            :disabled="true || !elementDict.withholdDate.writable"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            no="9"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.printParam4.viewable" slot="printParam4">
          <line-label slot="label" :class="elementDict.printParam4.isRequire ? 'blue' : ''" :label="elementDict.printParam4.label" />
          <el-select v-model="form.printParam4" no="printParam4" :disabled="readonly || !elementDict.printParam4.writable" :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')" filterable allow-create style="width: 100%;">
            <el-option
              v-for="(item,index) in pm.printParam4Type"
              :key="index"
              :label="item.label"
              :value="item.data"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.printParam5.viewable" slot="printParam5">
          <line-label slot="label" :class="elementDict.printParam5.isRequire ? 'blue' : ''" :label="elementDict.printParam5.label" />
          <el-select v-model="form.printParam5" no="printParam5" :disabled="readonly || !elementDict.printParam5.writable" :placeholder="readonly ? '': $t('CargoMsg.Cargo_PleaseSelect')" style="width: 100%;">
            <el-option
              v-for="(item,index) in pm.printParam5Type"
              :key="index"
              :label="item.label"
              :value="item.data"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.seaeq.viewable" slot="seaeq">
          <line-label slot="label" :class="elementDict.seaeq.isRequire ? 'blue' : ''" :label="elementDict.seaeq.label" />
          <el-input
            v-model="form.seaeq"
            :disabled="readonly || !elementDict.seaeq.writable"
            no="seaeq"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.ContainerAmount'),form.seaeq,val=>{form.seaeq=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.container.viewable" slot="container">
          <line-label slot="label" :class="elementDict.container.isRequire ? 'blue' : ''" :label="elementDict.container.label" />
          <el-input
            v-model="form.container"
            :disabled="readonly || !elementDict.container.writable"
            no="container"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.CNTRNOSSEALNOS'),form.container,val=>{form.container=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.txtCarrierScAc.viewable" slot="txtCarrierScAc">
          <line-label slot="label" :class="elementDict.txtCarrierScAc.isRequire ? 'blue' : ''" :label="elementDict.txtCarrierScAc.label" />
          <el-input :value="job.carrierScac || txtCarrierScAc" :disabled="true" no="10" />
        </el-form-item>
        <el-form-item v-if="elementDict.withholdReason && elementDict.withholdReason.viewable" slot="withholdReason">
          <line-label slot="label" :class="elementDict.withholdReason.isRequire ? 'blue' : ''" :label="elementDict.withholdReason.label" />
          <el-input :value="form.withholdReason" :disabled="true" no="25" />
        </el-form-item>
        <el-form-item v-if="elementDict.txtBookingAgentScAc.viewable" slot="txtBookingAgentScAc">
          <line-label slot="label" :class="elementDict.txtBookingAgentScAc.isRequire ? 'blue' : ''" :label="elementDict.txtBookingAgentScAc.label" />
          <el-input :value="txtBookingAgentScAc" :disabled="true" no="11" />
        </el-form-item>
        <el-form-item v-if="elementDict.shipperTel.viewable" slot="shipperTel">
          <line-label slot="label" :class="elementDict.shipperTel.isRequire ? 'blue' : ''" :label="elementDict.shipperTel.label" />
          <el-input v-model="form.shipperTel" no="shipperTel" :disabled="readonly || !elementDict.shipperTel.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.consigneeTel.viewable" slot="consigneeTel">
          <line-label slot="label" :class="elementDict.consigneeTel.isRequire ? 'blue' : ''" :label="elementDict.consigneeTel.label" />
          <el-input v-model="form.consigneeTel" no="consigneeTel" :disabled="readonly || !elementDict.consigneeTel.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.notifyTel.viewable" slot="notifyTel">
          <line-label slot="label" :class="elementDict.notifyTel.isRequire ? 'blue' : ''" :label="elementDict.notifyTel.label" />
          <el-input v-model="form.notifyTel" no="notifyTel" :disabled="readonly || !elementDict.notifyTel.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.portRequirement.viewable" slot="portRequirement">
          <line-label slot="label" :class="elementDict.portRequirement.isRequire ? 'blue' : ''" :label="elementDict.portRequirement.label" />
          <el-input v-model="form.portRequirement" :disabled="readonly || !elementDict.portRequirement.writable" no="portRequirement" type="textarea" :rows="5" />
          <div style="display: flex;line-height: 16px;margin-top: 5px;cursor: pointer;" @click="downloadAttachment(form.regionWarehouseMappingUuid)">
            <i class="el-icon-paperclip" style="font-size: 16px;" />
            <div style="font-size: 12px;text-decoration: underline;color: blue;">{{ $t('SystemMaintenance.PortRequirementsRelatedDocuments') }}</div>
          </div>
        </el-form-item>
        <div v-show="elementDict.billOfLadingPackingInfo.viewable" key="billOfLadingPackingInfo" slot="billOfLadingPackingInfo" class="section">
          <span class="title">{{ $t('SeaExport.BillOfLadingPackingInfo') }}</span>
          <div style="display:flex;flex-direction:column">
            <div v-show="isEdit" style="padding:5px 0">
              <el-button no="AddPackingInfo" type="primary" @click="cargoDocUsageSelectedDialog.visible=true">{{ $t('SeaExport.AddPackingInfo') }}</el-button>
              <el-button no="RemovePackingInfo" type="primary" @click="removeContainerUsageClickHandler">{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
            </div>
            <cargo-ag-grid
              no="BillOfLadingPackingInfo"
              :grid-options="container.gridOptions"
              :column-defs="containerColumnDefs"
              :row-data="ediContainerFinalRowData"
              style="width:100%;height:350px"
              @gridReady="params=>{container.gridApi=params.api}"
            />
          </div>
        </div>
        <div v-show="elementDict.freightChargesInfo.viewable" key="freightChargesInfo" slot="freightChargesInfo" class="section">
          <span class="title">{{ $t('SeaExport.freightChargesInfo') }}</span>
          <div style="display:flex;flex-direction:column">
            <div v-show="isEdit" style="padding:5px 0">
              <el-button no="Add2" type="primary" @click="showEditDialog(true)">{{ $t('SeaExport.Add') }}</el-button>
              <el-button no="Edit2" type="primary" @click="showEditDialog(false)">{{ $t('SeaExport.Edit') }}</el-button>
              <el-button no="Delete2" type="danger" @click="remove">{{ $t('SeaExport.Delete') }}</el-button>
            </div>
            <cargo-ag-grid
              no="freightChargesInfo"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="finalRowData"
              style="width:100%;height:350px"
              @gridReady="params=>{gridApi=params.api}"
            />
            <div style="padding:5px 0;font-size:12px">
              <span style="color:#0A0AFF">{{ $t('SeaExport.freightChargesUSDTotal') }}</span>
              <i style="margin-left:15px;margin-right:5px">{{ form.freightChargeEnUpper }}</i>
              <i>({{ NumberUtils.formatNumber(form.freightChargeTotal, 2) }})</i>
            </div>
          </div>
        </div>
      </tab-HBL2-UICustom-layout>
      <!-- 高级文本弹框 -->
      <el-dialog
        v-el-drag-dialog
        :visible.sync="advanceTextDialog.visible"
        :title="advanceTextDialog.title"
        width="600px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <cargo-rich-textarea
          ref="advanceTextDialogTextarea"
          v-model="advanceTextDialog.value"
          :text-chars="advanceTextDialog.formatObj.maxChar"
          :auto-uppercase="advanceTextDialog.isUppercase"
          :warning-count="advanceTextDialog.formatObj.warningCount"
          :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
          :disabled="readonly"
          style="height: 320px;"
          no="12"
        />
        <span slot="footer">
          <el-button v-show="isEdit" type="primary" no="13" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
          <el-button
            no="14"
            @click="advanceTextDialog.visible=false"
          >{{ $t('common.btn.close') }}</el-button>
        </span>
      </el-dialog>
      <!-- 收发通地址弹窗 -->
      <bill-address-dialog :visible.sync="billAddressDialog.visible" :job="job" :params="form" @callback="codeSearchCallback" />
      <!-- 工作单检索弹窗 -->
      <job-no-transcribe-dialog
        :visible.sync="searchJobNoDialog.visible"
        :params="searchJobNoDialog.params"
        @selected="searchJobNoDialog.selectHandler"
      />
      <!-- 邀请对单弹窗 -->
      <email-input
        v-if="emailInput.visible"
        :visible.sync="emailInput.visible"
        :context="context"
        :job="job"
        source="tabHBL2"
        :is-copy-link="true"
        :job-eamil-data="jobEamilData"
        :send-email-data="emailInput"
        :send-call-back="onEmailExecute"
      />
      <!-- 抄录弹窗 -->
      <transcribe-dialog :visible.sync="transcribeDialog.visible" :job="job" @callback="transcribeCallback" />
      <!-- 反恐地址格式化弹窗 -->
      <address-format-dialog
        :visible.sync="addressFormatDialog.visible"
        :job="job"
        :params="addressFormatDialog.params"
      />
      <!-- 选择装箱信息弹窗 -->
      <add-cargo-doc-container-dialog
        :visible.sync="cargoDocUsageSelectedDialog.visible"
        :job="job"
        :doc-type="CargoDocConsts.HBL2"
        :uuid-not-empty="true"
        :cargo-docs="job.typeHBL === BillType.SPLIT_BILL_TYPE.code ? splitOrderFinalRowData : null"
        @callback="cargoDocUsageSelectedDialog.callback"
      />
      <!-- 打印报表对话框 -->
      <cargo-template-selector-dialog
        :visible.sync="templateSelectorDialog.visible"
        :ctx="templateSelectorDialog.ctx"
        :category="templateSelectorDialog.category"
        :data="templateSelectorDialog.data"
        :context="context"
        :pre-print-callback="prePrintCallback"
        :printed-callback="printedCallback"
        :v2-check-callback="v2CheckCallback"
        :return-main-callback="returnMainCallback"
      />
      <!-- 编辑弹窗 -->
      <el-dialog
        v-el-drag-dialog
        :visible.sync="editDialog.visible"
        :title="editDialog.title"
        width="465px"
        :close-on-click-modal="false"
      >
        <div class="app-main-inner-row" style="padding-bottom: 10px;">
          <el-form label-width="100px" label-position="left">
            <el-form-item :label="$t('SeaExport.ChargeItem')">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_ChargeItem"
                filterable
                :default-value="editDialog.form.chargeItemId||''"
                style="width:100%;"
                no="15"
                @parentCallBack="p=>{editDialog.form.chargeItemId=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargeClause')">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :default-value="editDialog.form.paymentTermHBL"
                style="width:100%;"
                no="16"
                @parentCallBack="p=>{editDialog.form.paymentTermHBL=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Currency')">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Currency"
                filterable
                :default-value="editDialog.form.currency"
                style="width:100%;"
                no="17"
                @parentCallBack="p=>{editDialog.form.currency=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContainerSize')">
              <cargo-advance-select
                :select-type="selectTypeNames.local_cache_EQSize"
                filterable
                :default-value="editDialog.form.eqSize"
                style="width:100%;"
                no="18"
                @parentCallBack="p=>{editDialog.form.eqSize=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContainerType')">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_EQType"
                filterable
                :default-value="editDialog.form.eqType"
                style="width:100%;"
                no="19"
                @parentCallBack="p=>{editDialog.form.eqType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Quantity2')" :class="variableCss.quantity">
              <el-input-number
                v-model="editDialog.form.quantity"
                :precision="0"
                :controls="false"
                style="width:100%"
                no="20"
                @change="caculateAmount"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UnitRate')">
              <el-input-number
                v-model="editDialog.form.unitRate"
                :precision="2"
                :controls="false"
                style="width:100%"
                no="21"
                @change="caculateAmount"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Amount')">
              <el-input-number
                v-model="editDialog.form.amount"
                :precision="2"
                :controls="false"
                style="width:100%"
                no="22"
                @change="editDialog.form.unitRate=editDialog.form.amount"
              />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer">
          <el-button type="primary" no="23" @click="save">{{ $t('common.btn.save') }}</el-button>
          <el-button no="24" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </span>
      </el-dialog>
      <!-- 对单历史弹窗 -->
      <match-history-dialog :visible.sync="matchHistoryDialog.visible" :cargo-doc-uuid="form.uuid" />
      <!-- 查看编辑货物信息弹窗 -->
      <trade-detail-window
        :visible.sync="tradeDetailDialog.visible"
        :cargo-doc="form"
        :container-info="tradeDetailDialog.containerInfo"
        @callBackFun="reloadEDIContainer"
      />
    </div>
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      :file-size="cloudFile.fileSize"
      :file-category="cloudFile.fileCategory"
      :file-category-label="cloudFile.fileCategoryLabel"
      :upload-source="cloudFile.uploadSource"
      :other-param="cloudFile.otherParam"
      @uploadDone="onUploadDone"
    />
    <el-dialog
      :visible.sync="checkTheBLLog.visible"
      :title="$t('SeaExport.CheckTheBLCenterApiLog')"
      width="1000px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      top="5vh"
      custom-class="details-view settlement-notice"
    >
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-params.sync="checkTheBLLog.gridParams"
            :grid-options="checkTheBLLog.gridOptions"
            :column-defs="checkTheBLLog.columnDefs"
            :row-data="checkTheBLLog.rowData"
          />
        </div>
      </div>
    </el-dialog>
    <xhq-overseas-agent-feedback-dialog
      :visible.sync="xhqOverseasAgentFeedbackDialog.visible"
      :data="xhqOverseasAgentFeedbackDialog.data"
      :callback="xhqOverseasAgentFeedbackDialog.callback"
    />
    <!--保函上传文件-->
    <guarantee-file-dialog
      :visible.sync="guaranteeFileDialog.visible"
      :model="guaranteeFileDialog.model"
      :title="$t('Message.fileManagement')"
    />
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabHBL2UICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabHBL2UICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabHBL2 from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabHBL2'
import StrUtils from '@/utils/StrUtils'
import * as BillType from '@/class/cargo/model/parameters/BillType'

export default {
  name: 'TabHBL2UICustom',
  components: { tabHBL2UICustomLayout },
  extends: tabHBL2,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {}
    }
  },
  computed: {
    jobTypeHbl() {
      return this.job.typeHBL || BillType.NORMAL_BILL_TYPE.code
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    },
    jobTypeHbl() {
      this.loadPageConfig()
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        const pageType = this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code ? UICustomConstants.SEA_BOOKING_HBL_SPLIT : UICustomConstants.SEA_BOOKING_HBL_MERGE
        UICustomUtil.handleViewAndWrite(pageType, this.elementDict, row)
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
        const pageType = this.previewConfig.pageType
        if (pageType === UICustomConstants.SEA_BOOKING_HBL_SPLIT) {
          this.job.typeHBL = BillType.SPLIT_BILL_TYPE.code
        } else {
          this.job.typeHBL = BillType.MERGE_BILL_TYPE.code
        }
      } else {
        const pageType = this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code ? UICustomConstants.SEA_BOOKING_HBL_SPLIT : UICustomConstants.SEA_BOOKING_HBL_MERGE
        const pageConfig = UICustomUtil.getPageConfig(pageType, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    validateRequire(form) {
      for (const name in this.elementDict) {
        const element = this.elementDict[name]
        if (!(element.visible && element.writable && element.isRequire)) {
          continue
        }
        if (name === 'shipper') {
          let shipperLine = ''
          for (let i = 1; i <= 7; ++i) {
            shipperLine += form['shipperLine' + i]
          }
          if (StrUtils.isEmpty(shipperLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL2')
          }
          continue
        }
        if (name === 'consignee') {
          let consigneeLine = ''
          for (let i = 1; i <= 7; ++i) {
            consigneeLine += form['consigneeLine' + i]
          }
          if (StrUtils.isEmpty(consigneeLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL2')
          }
          continue
        }
        if (name === 'notify') {
          let notifyLine = ''
          for (let i = 1; i <= 7; ++i) {
            notifyLine += form['notifyLine' + i]
          }
          if (StrUtils.isEmpty(notifyLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL2')
          }
          continue
        }
        if (name === 'agentParty') {
          let agentPartyLine = ''
          for (let i = 1; i <= 7; ++i) {
            agentPartyLine += form['agentPartyLine' + i]
          }
          if (StrUtils.isEmpty(agentPartyLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL2')
          }
          continue
        }
        if (name === 'dispatchingPlaceCode') {
          if (StrUtils.isEmpty(form.dispatchingPlaceCode) || StrUtils.isEmpty(form.dispatchingPlace)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL2')
          }
          continue
        }
        if (name === 'loadingPortCode') {
          if (StrUtils.isEmpty(form.loadingPortCode) || StrUtils.isEmpty(form.loadingPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL2')
          }
          continue
        }
        if (name === 'dischargingPortCode') {
          if (StrUtils.isEmpty(form.dischargingPortCode) || StrUtils.isEmpty(form.dischargingPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL2')
          }
          continue
        }
        if (name === 'destinationPortCode') {
          if (StrUtils.isEmpty(form.destinationPortCode) || StrUtils.isEmpty(form.destinationPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL2')
          }
          continue
        }
        if (name === 'quantity' || name === 'weight' || name === 'cubage') {
          if (!this.isJydEditJobFields) {
            continue
          }
        }
        if (name === 'requestReleaseState') {
          continue
        }
        if (name === 'mblId') {
          if (this.pm.joinMBLs.filter(p => p.uuid).length === 0) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL2')
          }
          continue
        }
        if (element.fieldNames && element.fieldNames.length > 0) {
          for (const key of element.fieldNames) {
            const field = this.fieldDict[key]
            const label = element.fieldNames.length > 1 ? field.label : element.label
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabHBL2')
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.triggers{
  .operat-wrap{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    .el-checkbox{
      margin-right: 15px;
      &:first-of-type{
        margin-left: 20px;
      }
    }
  }
}
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/ input{
      border: 0;
      padding-right: 0 !important;
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
</style>
<style>
.messageIndex{
  z-index:99999 !important;
}
</style>
